import CenteredSpinner from 'components/CenteredSpinner/CenteredSpinner'
import { useContextUserQuery } from 'generated/types'
import React, { createContext, useState, useEffect } from 'react'
import { isAuthenticated } from 'utils/auth'

export interface UserData {
  email: string
}

export interface UserContextProps {
  userData: UserData
  setUserData: React.Dispatch<React.SetStateAction<UserData | null>>
}

export const UserContext = createContext<UserContextProps | null>(null)

export const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState<UserData>(null)

  const { data, loading } = useContextUserQuery({
    skip: !isAuthenticated(),
  })

  useEffect(() => {
    if (!loading && data && !userData) {
      setUserData({
        email: data.user.email,
      })
    }
  }, [loading, data, userData])

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {loading ? <CenteredSpinner /> : children}
    </UserContext.Provider>
  )
}
